import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { showPopupParts, setCarSelectedParts } from '../../../../../actions/price'
import { translation } from '../../../../../utils/helpers'

// Elements
import Button from '../../../../elements/button'
import Radio from '../../../../elements/radio'
import Check from '../../../../elements/check'
import Text from '../../../../elements/text'
import Grid from '../../../../elements/grid'
import Col from '../../../../elements/col'
import Row from '../../../../elements/row'
import PanelHeader from '../../../../elements/panelHeader'
import Inline from '../../../../elements/inline'
import Divider from '../../../../elements/divider'

class EstimationList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      selectedPart: {},
      selectedBodyPart: undefined,
      carItems: [],
      carPartItems: { tasks: [], extra: [], extents: [] }
    }
    this.close = this.close.bind(this)
    this.reset.bind(this)
    this.manualTaskId = 9000000000000000
    this.manualExtraId = 9000000000000000
  }
  componentDidMount () {
    this.init(this.props)
  }

  componentWillUnmount () {
    this.reset()
  }
  getTaskSide (key) {
    if (key.indexOf('tag') !== -1) {
      return 0
    }
    if (key.endsWith('-for')) {
      if (key.indexOf('venstre-') !== -1) return 5
      if (key.indexOf('hojre-') !== -1) return 6
    } else if (key.endsWith('-bag')) {
      if (key.indexOf('venstre-') !== -1) return 7
      if (key.indexOf('hojre-') !== -1) return 8
    }

    if (key.indexOf('venstre-') !== -1) {
      return 1
    } else if (key.indexOf('hojre-') !== -1) {
      return 2
    } else if (key.indexOf('for-') !== -1) {
      return 3
    } else if (key.indexOf('bag-') !== -1) {
      return 4
    }
    // console.log(key, ' - no side')
    return 0
  }
  setSelectedProp () {
    if (window.carHandler.priceCalcType !== 5 && window.carHandler.priceCalcType !== 10) {
      let part = this.state.selectedBodyPart
      let { carPartItems } = this.state
      let { carItems } = this.state
      if (part) {
        let tasks = Object.assign({}, carItems.tasks)
        let extra = Object.assign({}, carItems.extra)
        let extents = Object.assign([], carItems.extents)
        if (typeof (tasks) !== 'undefined') {
          tasks[part].map((item) => {
            item.IsSelected = false
            var id = part + '_' + item.EstimationTaskId
            if (item.EstimationTaskId === 0 && item.OrderEstimationTaskId > 0) id = part + '_' + item.OrderEstimationTaskId
            item.id = id
            return item
          })
        }
        if (typeof (extra) !== 'undefined') {
          extra[part].map((item) => {
            item.IsSelected = false
            var id = part + '_extra_' + item.EstimationExtraId
            item.id = id
            return item
          })
        }
        if (typeof (extents) !== 'undefined') {
          extents.map((item) => {
            item.IsSelected = false
            var id = part + '_extent_' + item.PriceModelExtentId
            item.id = id
            return item
          })
        }
        if (tasks !== undefined && part !== undefined) {
          let partTasks = tasks[part]
          this.props.price.Parts.map((pricePart) => {
            pricePart.EstimationTasks.map((estimationTask) => {
              let taskSide = this.getTaskSide(part)
              let indexI = part.indexOf(estimationTask.PartName)
              if (estimationTask.EstimationTaskId === 0 &&
                estimationTask.PartName === pricePart.Part.MappingName &&
                indexI > -1 && estimationTask.TaskSide === taskSide) {
                let filteredPartTasks = []
                partTasks.map((i) => {
                  if (typeof (i.OrderEstimationTaskId) !== 'undefined' &&
                    i.OrderEstimationTaskId === estimationTask.OrderEstimationTaskId) filteredPartTasks.push(i)
                })
                if (filteredPartTasks.length === 0 && typeof (estimationTask.OrderEstimationTaskId) !== 'undefined') {
                  let blankItem = {
                    id: estimationTask.PartName + '_' + estimationTask.OrderEstimationTaskId,
                    AE: 0,
                    EstimationTaskId: estimationTask.EstimationTaskId,
                    IsSelected: false,
                    Material: 0,
                    Name: '',
                    SortIndex: null
                  }
                  blankItem.OrderEstimationTaskId = estimationTask.OrderEstimationTaskId
                  blankItem.TaskName = estimationTask.TaskName
                  blankItem.IsDisabled = true
                  partTasks.push(blankItem)
                }
              } else {
                let estimationFilteredTasks = []
                partTasks.map((item) => {
                  if (item.OrderEstimationTaskId === estimationTask.OrderEstimationTaskId) {
                    estimationFilteredTasks.push(item)
                  }
                })
                let item = estimationFilteredTasks[0]
                if (typeof (item) !== 'undefined') {
                  item.IsDisabled = true
                }
              }
            })
          })
        }
        let filteredTasks = []
        tasks[part].map((item) => {
          if (item.EstimationTaskId === 0 && item.OrderEstimationTaskId === 0) {
            filteredTasks.push(item)
          }
        })
        if (typeof (tasks) !== 'undefined' && typeof (tasks[part]) !== 'undefined' && filteredTasks.length === 0) {
          this.manualTaskId++
          let newTask = {
            id: part + '_' + this.manualTaskId,
            OrderEstimationTaskId: 0,
            EstimationTaskId: 0,
            IsSelected: false,
            IsDisabled: false,
            SortIndex: null,
            TaskName: ''
          }
          tasks[part].push(newTask)
        }
        let filteredExtra = []
        extra[part].map((item) => {
          if (item.EstimationExtraId === this.manualExtraId + 1) {
            filteredExtra.push(item)
          }
        })
        if (typeof (extra) !== 'undefined' && typeof (extra[part]) !== 'undefined' && filteredExtra.length === 0) {
          extra[part].push(this.getBlankExtra(part))
        }

        let filteredExtents = []
        extents.map((item) => {
          if (item.id === part + '_extent_' + 0) filteredExtents.push(item)
        })
        if (typeof (extents) !== 'undefined' && filteredExtents.length === 0) {
          extents.push({
            id: part + '_extent_' + 0,
            Group: 1,
            IsSelected: false,
            PriceModelExtentId: 0,
            SortIndex: null,
            Type: ''
          })  // sest
        } else {
          filteredExtents.map((item) => { item.Type = '' })
        }
        carPartItems.tasks = Object.assign({}, tasks)
        carPartItems.extents = extents
        carPartItems.extra = extra
        this.setState({
          carPartItems: carPartItems
        })
      }
    }
  }
  getBlankExtra (part) {
    this.manualExtraId++
    return {
      id: part + '_extra_' + this.manualExtraId,
      AE: 0,
      EstimationExtraId: this.manualExtraId,
      EstimationTaskId: this.manualExtraId,
      IsSelected: false,
      Material: 0,
      Name: '',
      SortIndex: null
    }
  }
  reset (props) {
    this.manualTaskId = 9000000000000000
    this.manualExtraId = 9000000000000000
    this.setState({
      selectedPart: {},
      selectedBodyPart: typeof (props) === 'undefined' ? undefined : props.selectedBodyPart,
      carItems: [],
      carPartItems: { tasks: [], extra: [], extents: [] }
    })
  }

  componentWillReceiveProps (nextProps) {
    // console.log('[EstimationList props recieived]', nextProps, this.props)
    if (
      this.props.selectedBodyPart !== nextProps.selectedBodyPart ||
      this.props.selectedBodyPartSide !== nextProps.selectedBodyPartSide || !isEqual(nextProps.carItems, this.props.carItems)) {
      this.reset(nextProps)
      if (nextProps.show) {
        this.init(nextProps)
      } else {
        this.reset(nextProps)
      }
    }
  }
  init (props) {
    this.reset(props)
    this.setState({
      selectedBodyPart: props.selectedBodyPart,
      carItems: typeof (props) !== 'undefined' ? Object.assign({}, props.carItems) : { tasks: [], extra: [], extents: [] },
      carPartItems: { tasks: [], extra: [], extents: [] }
    }, () => {
      if (props.show !== true) return null
      this.setSelectedProp()
    })
  }

  render () {
    if (Number(window.carHandler.priceCalcType) !== 1) return null
    let part = this.props.selectedBodyPart
    var tasks = this.state.carPartItems.tasks[part]
    var extra = this.state.carPartItems.extra[part]
    var extents = this.state.carPartItems.extents

    // Dont render popup No tasks, return null
    if (typeof tasks === 'undefined' || tasks.length === 0) {
      return null
    }
    const resetSelected = (items) => {
      items.map((item) => {
        item.IsSelected = false
      })
    }
    const onChange = (e, type) => {
      let { carPartItems } = { ...this.state }
      if (e.target.name === 'extra') {
        let item = carPartItems.extra[this.state.selectedBodyPart].filter((x) => x.id === e.target.id)[0]
        if (item.Name.length > 0) item.IsSelected = e.target.checked
      }
      if (e.target.name === 'task') {
        resetSelected(carPartItems.tasks[this.state.selectedBodyPart])
        let item = carPartItems.tasks[this.state.selectedBodyPart].filter((x) => x.id === e.target.id)[0]
        item.IsSelected = true
      }
      if (e.target.name === 'extent') {
        resetSelected(carPartItems.extents)
        let item = carPartItems.extents.filter((x) => x.id === e.target.id)[0]
        item.IsSelected = true
      }
      if (['TaskName', 'Type', 'Name'].includes(e.target.name)) {
        let item = {}
        if (e.target.name === 'TaskName') item = carPartItems.tasks[this.state.selectedBodyPart].filter((x) => x.id === e.target.id)[0]
        if (e.target.name === 'Type') item = carPartItems.extents.filter((x) => x.id === e.target.id)[0]
        if (e.target.name === 'Name') item = carPartItems.extra[this.state.selectedBodyPart].filter((x) => x.id === e.target.id)[0]
        if (!item.IsSelected) {
          if (e.target.name !== 'Name') resetSelected(e.target.name === 'Type' ? carPartItems.extents : carPartItems.tasks[this.state.selectedBodyPart])
          item.IsSelected = true
        }
        if (e.target.name === 'Name' && carPartItems.extra[this.state.selectedBodyPart][carPartItems.extra[this.state.selectedBodyPart].length - 1].id === item.id) {
          // add new input if this is the last one
          carPartItems.extra[this.state.selectedBodyPart].push(this.getBlankExtra(this.state.selectedBodyPart))
        }
        item[e.target.name] = e.target.value
        if (item.IsSelected && e.target.name === 'Name') {
          if (item.Name.length === 0) {
            item.IsSelected = false
            // Remove last input field if empty
            let lastItem = carPartItems.extra[this.state.selectedBodyPart][carPartItems.extra[this.state.selectedBodyPart].length - 1]
            if (!lastItem.IsSelected && lastItem.Name === '' && item.id !== lastItem.id) {
              carPartItems.extra[this.state.selectedBodyPart].splice(carPartItems.extra[this.state.selectedBodyPart].length - 1, 1)
            }
          }
        }
      }
      if (['AE', 'Material'].includes(e.target.name)) {
        let item = carPartItems.extra[this.state.selectedBodyPart].filter((x) => x.id === e.target.id)[0]
        item[e.target.name] = e.target.value
      }
      this.setState({
        carPartItems: carPartItems
      })
    }
    const mapTasks = (item, key) => {
      var id = item.id
      var disabled = item.IsDisabled === true
      let isCustom = item.OrderEstimationTaskId === 0
      if (!isCustom && item.EstimationTaskId === 0 && item.TaskName === '') return null
      // let radioClass = 'carRadio__custom'
      // if (isCustom) radioClass += ' custom'
      return (
        <div className='customRadio' key={'11task' + id}>
          {isCustom && (
            <Inline spacing={0} alignChildren='center'>
              <Radio simple name='task' id={id} value={id} disabled={disabled} checked={item.IsSelected} onChange={onChange} />
              <Text size='s' name={'TaskName'} id={id} value={item.TaskName} placeholder={translation('227')} onChange={onChange} />
            </Inline>
          )}
          {!isCustom && <Radio labelText={item.TaskName} name='task' id={id} value={id} disabled={disabled} checked={item.IsSelected} onChange={onChange} />}
        </div>
      )
    }
    const mapExtents = (item, key) => {
      var id = item.id
      let isCustom = item.PriceModelExtentId === 0
      // let radioClass = 'carRadio__custom'
      // if (isCustom) radioClass += ' custom'
      return (
        <div className='customRadio' key={'extent' + id}>
          {isCustom && (
            <Inline spacing={0} alignChildren='center'>
              <Radio simple name='extent' id={id} value={id} checked={item.IsSelected} onChange={onChange} />
              <Text size='s' name={'Type'} id={id} value={item.Type} placeholder={translation('227')} onChange={onChange} />
            </Inline>
          )}
          {!isCustom && <Radio labelText={item.Type} name='extent' id={id} value={id} checked={item.IsSelected} onChange={onChange} />}
        </div>
      )
    }
    const mapExtra = (item, key) => {
      var id = item.id
      let isCustom = item.EstimationExtraId > 9000000000000000
      // let widthLeft = ' sixty'
      // let widthRight = ' fourty'
      // let leftClass = 'leftcontent' + widthLeft
      // let rightClass = 'rightcontent' + widthRight
      // let checkboxClass = 'carCheckbox__custom'
      // if (isCustom) checkboxClass += ' custom'
      // if (!isCustom) checkboxClass += ' standard'
      return (
        <Grid key={'extra' + id} cols={[2, 0.50, 0.50]} align='center'>
          {isCustom ? (
            <Inline alignChildren='center' spacing={0}>
              <Check spacing={1} name={'extra'} id={id} value={id} checked={item.IsSelected === true} onChange={onChange} />
              <Text size='s' name={'Name'} id={id} value={item.Name} placeholder={translation('227')} onChange={onChange} />
            </Inline>
          ) : (
            <Check spacing={1} labelText={item.Name} name={'extra'} id={id} value={id} checked={item.IsSelected === true} onChange={onChange} />
          )}
          <Text size='s' name={'AE'} id={id} value={item.AE} onChange={onChange} />
          <Text size='s' name={'Material'} id={id} value={item.Material} onChange={onChange} />
        </Grid>
      )
    }
    const submit = () => {
      let tasks = Object.assign([], this.state.carPartItems.tasks[this.state.selectedBodyPart])
      let extras = Object.assign([], this.state.carPartItems.extra[this.state.selectedBodyPart])
      let extents = Object.assign([], this.state.carPartItems.extents)
      let tasksToSubmit = tasks.filter((item) => item.IsSelected)
      let extrasToSubmit = extras.filter((item) => item.IsSelected)
      let extentsToSubmit = extents.filter((item) => item.IsSelected)
      let taskItem = tasksToSubmit[0]
      let extentItem = extentsToSubmit[0]
      let extraItems = []
      extrasToSubmit.map((item) => {
        extraItems.push({
          id: item.id,
          ae: item.AE,
          mat: item.Material,
          isnew: item.EstimationExtraId > 9000000000000000,
          name: item.Name
        })
      })

      let submitObject = {
        isEstimation: true,
        name: typeof (taskItem) !== 'undefined' ? taskItem.id : (extrasToSubmit !== undefined && extrasToSubmit.length > 0 ? extrasToSubmit[0].id : ''),
        isnew: typeof (taskItem) !== 'undefined' ? taskItem.OrderEstimationTaskId === 0 : '',
        taskname: typeof (taskItem) !== 'undefined' ? taskItem.TaskName : '',
        value: {
          extra: extraItems
        }
      }
      if (typeof (extentItem) !== 'undefined') {
        submitObject.value = {
          extent: extentItem.id,
          type: extentItem.Type,
          isnew: extentItem.PriceModelExtentId === 0,
          extra: extraItems
        }
      }
      let toSubmit = []
      toSubmit.push(submitObject)
      this.props.setCarSelectedParts(toSubmit)
      this.close()
    }
    return (
      <div>
        <Row>
          <Col>
            <PanelHeader text={translation('1227')} />
            {tasks.map(mapTasks)}
          </Col>
          <Col>
            <PanelHeader text={translation('889')} />
            {extents.map(mapExtents)}
          </Col>
        </Row>
        <Row>
          <Col span='2'>
            <PanelHeader text={translation('13374')} />
            <Grid cols={[2, 0.5, 0.5]}>
              <span />
              <span>{translation('885')}</span>
              <span>{translation('13443')}</span>
            </Grid>
            {extra.map(mapExtra)}
            <Divider size={3} noLine />
          </Col>

          <Button onClick={submit} labelText={translation('1208')} />
        </Row>
      </div>
    )
  }

  close () {
    this.reset(this.props)
    this.setState({
      carItems: []
    })
    this.props.close()
  }
}
EstimationList.defaultProps = {
}
EstimationList.propTypes = {
  close: PropTypes.func.isRequired
}
EstimationList.contextTypes = {
  // t: React.PropTypes.func.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    price: state.price.price,
    order: state.orders.order,
    selectedBodyPart: state.price.selectedBodyPart,
    selectedBodyPartSide: state.price.selectedBodyPartSide,
    carPriceParts: state.price.carPriceParts,
    carItems: state.price.carItems
  }
}

export default connect(mapStateToProps, {
  showPopupParts,
  setCarSelectedParts
})(EstimationList)



// WEBPACK FOOTER //
// ./src/app/shared/components/Car/CarPopup/EstimationList/index.js